import { ShipmentQuoteList } from "../ShipmentQuoteList";

interface Props {
  shipment: CondensedShipment | undefined;
}

export function ShipperQuoteTab(props: Props) {
  const { shipment } = props;

  if (shipment === undefined) {
    return null;
  }
  return <ShipmentQuoteList shipment={shipment as ShipperCondensedShipment} />;
}
